import BaseFeature from '../../foundation/base/base';

export class Content extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;
		this.contentTable = document.querySelectorAll('.o-content-block__content table');
		this.inputElements = document.querySelectorAll('.o-content-block input[type=radio]');
		this.select = document.querySelectorAll('.o-content-block select');
		this.responsiveTable();
		this.log('Content');

		window.addEventListener('load', () => {
			this.moduleItemCards = document.querySelectorAll('.m-module-item__card');
		});

		this.hTags = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
		this.removeEmptyHTags();
	}

	removeEmptyHTags() {
		if (this.hTags) {
			Array.prototype.slice.call(this.hTags).forEach((hTag) => {
				if (hTag.innerHtml === '') {
					hTag.remove();
				}
			});
		}
	}

	responsiveTable() {
		this.inputElements.forEach((inputs) => {
			inputs.setAttribute('tabindex', '0');
		});
		this.select.forEach((selects) => {
			selects.setAttribute('tabindex', '0');
		});
		for (let i = 0; i < this.contentTable.length; i++) {
			const tableWrap = document.createElement('div');
			tableWrap.classList.add('table-responsive');
			if (!this.contentTable[i].parentNode.classList.contains('table-responsive')) {
				this.contentTable[i].parentNode.insertBefore(tableWrap, this.contentTable[i]);
				tableWrap.appendChild(this.contentTable[i]);
			}
		}
	}
}

export default Content;
